/**
 * The room on the right a docked Genie takes (GEN5-5185), set by GlobalLayout.
 * Page content moves aside on its own; an element with `position: fixed` is
 * placed against the viewport, so it offsets itself by this instead.
 */
export const PAGE_RIGHT_INSET_VARIABLE = "--admin-page-right-inset";

/** `right` for a fixed element `offset` px from the page's right edge. */
export const pageRightInset = (offset: number) =>
  `calc(${offset}px + var(${PAGE_RIGHT_INSET_VARIABLE}, 0px))`;
